import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";
import { filterNavSectionsForUser } from "../utils/roleAccess";
import SidebarItem from "./SidebarItem";

export default function Sidebar({ collapsed, mobileOpen, mobile, width }) {
  const { user } = useAuth();
  const navSections = useMemo(
    () => filterNavSectionsForUser(user),
    [user]
  );

  return (
    <aside
      className={`app-sidebar ${collapsed ? "collapsed" : ""} ${mobile && !mobileOpen ? "hidden" : ""}`.trim()}
      data-collapsed={collapsed ? "true" : "false"}
      style={{ width }}
    >
      <div className="sidebar-inner">
        <div className="sidebar-brand">
          {collapsed ? (
            <img
              className="sidebar-brand-mark"
              src="/calling-mark.svg"
              alt="Calling"
            />
          ) : (
            <img
              className="sidebar-brand-logo"
              src="/calling-logo.svg"
              alt="Calling"
            />
          )}
        </div>
        
        <nav className="sidebar-nav" aria-label="Main navigation">
          {navSections.map((section, sectionIndex) => (
            <div key={section.title} className="sidebar-section">
              {!collapsed && (
                <div className="sidebar-section-title">
                  {section.title}
                </div>
              )}
              <div className="sidebar-section-items">
                {section.items.map((item) => (
                  <SidebarItem
                    key={item.id}
                    item={item}
                    collapsed={collapsed && !mobile}
                  />
                ))}
              </div>
              {sectionIndex < navSections.length - 1 && !collapsed && (
                <div className="sidebar-section-divider" aria-hidden="true" />
              )}
            </div>
          ))}
        </nav>
        
        {user ? (
          <div className="sidebar-footer">
            <div className={`sidebar-profile-card ${collapsed && !mobile ? "collapsed" : ""}`.trim()}>
              <span className="sidebar-profile-avatar">{user.avatarInitials || "AA"}</span>
              {!(collapsed && !mobile) ? (
                <span className="sidebar-profile-copy">
                  <strong>{user.name || user.username || "Nexora User"}</strong>
                  <small>{user.role || "Team member"}</small>
                </span>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </aside>
  );
}
